import _ from 'lodash';

import { combineReducers } from 'redux';

import types from 'frontend/state/actionTypes';
import { setterReducer } from 'frontend/state/utils';

const INITIAL_SOULBINDS = [];
const soulbindsReducer = (state = INITIAL_SOULBINDS, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_OPTIMIZE_TEXT: {
      const soulbinds = _.get(payload, 'character.soulbinds');
      if (soulbinds) {
        const active = _.find(soulbinds, { active: true });
        if (active) {
          return [active.id];
        }
      }
      return INITIAL_SOULBINDS;
    }
    case types.TOGGLE_OPTIMIZE_SOULBIND: {
      return _.xor(state, [payload]);
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      return payload.optimize.soulbinds || INITIAL_SOULBINDS;
    }
    default:
      return state;
  }
};

const INITIAL_SOULBIND_GROUPS = [];
const soulbindGroupsReducer = (state = INITIAL_SOULBIND_GROUPS, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_OPTIMIZE_TEXT: {
      const selected = [];
      const soulbinds = _.get(payload, 'character.soulbinds');
      if (soulbinds) {
        _.each(soulbinds, soulbind => {
          _.each(soulbind.talents, talent => {
            if (talent && talent.choiceIndex) {
              selected.push({
                soulbindId: soulbind.id,
                row: talent.choiceIndex[0],
                col: talent.choiceIndex[1],
              });
            }
            // TODO: Log/warn if we can't find a soulbind talent
          });
        });
        // remove any dupes that may have popped up
        return _.uniqBy(selected, s => `${s.soulbindId}-${s.row}-${s.col}`);
      }
      return INITIAL_SOULBIND_GROUPS;
    }
    case types.TOGGLE_OPTIMIZE_SOULBIND_GROUP: {
      return _.xorBy(state, [payload], it => _.join(_.values(it)));
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      return payload.optimize.soulbindGroups || INITIAL_SOULBIND_GROUPS;
    }
    default:
      return state;
  }
};

const INITIAL_CONDUITS = [];
const conduitsReducer = (state = INITIAL_CONDUITS, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_OPTIMIZE_TEXT: {
      const selected = [];
      const activeSoulbind = _.find(_.get(payload, 'character.soulbinds'), { active: true });
      if (activeSoulbind) {
        _.each(activeSoulbind.talents, talent => {
          if (talent.rank) {
            selected.push({
              id: talent.id,
              rank: talent.rank,
            });
          }
        });
        return selected;
      }
      return INITIAL_CONDUITS;
    }
    case types.TOGGLE_OPTIMIZE_CONDUIT:
      return _.xorBy(state, [payload], 'id');
    case types.LOAD_OPTIMIZE_REPORT: {
      return payload.optimize.conduits || INITIAL_CONDUITS;
    }
    default:
      return state;
  }
};

const INITIAL_SOULBINDS_MODIFIED = false;
const soulbindsModifiedReducer = (state = INITIAL_SOULBINDS_MODIFIED, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.INPUT_OPTIMIZE_TEXT:
      return false;
    case types.TOGGLE_OPTIMIZE_SOULBIND:
    case types.TOGGLE_OPTIMIZE_SOULBIND_GROUP:
    case types.TOGGLE_OPTIMIZE_CONDUIT:
      return true;
    case types.LOAD_OPTIMIZE_REPORT:
      return payload.optimize.soulbindsModified || INITIAL_SOULBINDS_MODIFIED;
    default:
      return state;
  }
};


export default combineReducers({
  soulbinds: soulbindsReducer,
  soulbindGroups: soulbindGroupsReducer,
  conduits: conduitsReducer,
  conduitRankOverride: setterReducer({
    set: types.CHOOSE_CONDUIT_RANK_OVERRIDE,
    initial: 0,
    reset: types.RESET_OPTIMIZE,
    custom: (state, action) => {
      const { type, payload } = action;
      switch (type) {
        case types.LOAD_OPTIMIZE_REPORT:
          return payload.optimize.conduitRankOverride || 0;
        default:
          return state;
      }
    },
  }),
  allSoulbinds: setterReducer({
    set: types.SET_OPTIMIZE_ALL_SOULBINDS,
    initial: false,
    reset: types.RESET_OPTIMIZE,
    custom: (state, action) => {
      const { type, payload } = action;
      switch (type) {
        case types.LOAD_OPTIMIZE_REPORT:
          return payload.optimize.allSoulbinds || false;
        default:
          return state;
      }
    },
  }),
  allCovenants: setterReducer({
    set: types.SET_OPTIMIZE_ALL_COVENANTS,
    initial: false,
    reset: types.RESET_OPTIMIZE,
  }),
  allConduits: setterReducer({
    set: types.SET_OPTIMIZE_ALL_CONDUITS,
    initial: false,
    reset: types.RESET_OPTIMIZE,
    custom: (state, action) => {
      const { type, payload } = action;
      switch (type) {
        case types.LOAD_OPTIMIZE_REPORT:
          return payload.optimize.allConduits || false;
        default:
          return state;
      }
    },
  }),
  soulbindsModified: soulbindsModifiedReducer,
});

const base = state => state.simbot.optimize.covenants;
const get = path => state => _.get(base(state), path);

export const selectors = {
  soulbinds: get('soulbinds'),
  soulbindGroups: get('soulbindGroups'),
  conduits: get('conduits'),
  conduitRankOverride: state => {
    // only return the override if allConduits is chosen
    return base(state).allConduits ? base(state).conduitRankOverride : 0;
  },
  allSoulbinds: get('allSoulbinds'),
  allCovenants: get('allCovenants'),
  allConduits: get('allConduits'),
  soulbindsModified: get('soulbindsModified'),
};
